module.exports = __webpack_public_path__ + "assets/img/kefu-f71b45a2.png";